/**
 * Зависимости
 */
import './polyfills';
import '../../sections/first-screen';
import '../../sections/location';
import '../../sections/documents';
import '../../sections/progress';
import '../../sections/action-section';
import '../../sections/purchase';
import '../../sections/contacts';
import '../../sections/flats';
import '../../components/up-button';
// Ипортируем плашку о старых браузерах праямо в app.js, чтобы было больше баллов в lighthouse
// import '../../components/alert-old-browser';
import {
    fixPopupHeader,
    initCallbackForm,
    initCallbackPopups,
    initHeader,
    initMobileMenu,
    initPageReveal,
    initPrintPdf
} from './common';
import Cookies from 'js-cookie';
import CookiesNotice from '../../components/cookies-notice';
import Favorite from 'components/favorite';
import Html2Pdf from 'components/html2pdf';
import Mortgage from 'components/mortgage';
import MortgageUtils from '/components/mortgage/utils';
import Observer from 'common/scripts/observer';
import parametric from 'components/parametric';
import Popup from 'components/popup';
import ScrollBy from 'components/scrollBy';
import Slider from 'components/slider';
import yall from 'yall-js';

const U = new MortgageUtils();
const observer = new Observer();

// Поведение шапки
const headerWrap = document.querySelector('.j-header');

if (headerWrap) {
    initHeader(headerWrap);
}

// Поведение меню
const burgerMenuSelector = document.querySelector('.j-burger-menu');

if (burgerMenuSelector) {
    initMobileMenu(burgerMenuSelector, headerWrap);
}

// Попапы обратной связи и инциализация формы
const popupLinks = Array.from(document.querySelectorAll('.j-popup-callback-call'));

if (popupLinks.length) {
    initCallbackPopups(popupLinks);
    initCallbackForm();
}

// При открытии попапа сдвигаем шапку на ширину сколл-бара.
fixPopupHeader(headerWrap);

// Cкролл по якорям
const anchors = Array.from(document.querySelectorAll('.j-anchor'));

if (anchors.length) {
    const scrollBy = new ScrollBy();

    scrollBy.init({
        takeElements: [headerWrap],
        anchors
    });

    observer.subscribe('anchorChangeSection', (id) => {
        anchors.forEach((item) => {
            item.classList.remove('is-active');

            const href = item.getAttribute('href');

            if (href === id || href === `/${id}`) {
                item.classList.add('is-active');
            }
        });
    });
}

// Большой слайдер
let slider = {};
const sliderWrap = document.querySelector('.j-slider');

if (sliderWrap) {
    slider = new Slider();

    slider.init({
        slider       : sliderWrap,
        dots         : false,
        thumbnails   : false,
        arrow        : true,
        counter      : true,
        arrowPosition: 'caption',
        caption      : true,
        modify       : 'big_slide',
        infinityLoop : true
    });
}

// Подключение мелких галлерей
const slidersMini = Array.from(document.querySelectorAll('.j-slider-mini'));

if (slidersMini.length) {
    slidersMini.forEach((item) => {
        const sliderMini = new Slider();

        sliderMini.init({
            slider       : item,
            dots         : false,
            thumbnails   : false,
            arrow        : true,
            counter      : true,
            arrowPosition: 'caption',
            modify       : 'mini_slide',
            infinityLoop : true
        });
    });
}

// Подключение параметрического поиска
const id = '#parametric';
const parametricWrap = document.querySelector(id);

if (parametricWrap) {
    // тип выборщика (1 - квартиры / 2 - коммерция)
    const parametricType = Number(parametricWrap.dataset.estateType) || 1;

    parametric({
        id,
        // количество квартир на 1 странице
        showItemPage  : 6,
        // брейкпоинт для смены вида карточки/таблицa
        viewBreakpoint: 960,
        estateType    : parametricType
    });
}

// Подключение генератора pdf
const pdfLinks = Array.from(document.querySelectorAll('.j-html2pdf'));

if (pdfLinks.length) {
    const html2pdf = new Html2Pdf();

    html2pdf.init({
        targets    : pdfLinks,
        autoload   : true,
        orientation: 'portrait',
        quality    : 5,
        pageBreak  : '.pdf__page-break'
    });
}

/**
 * Калькулятор ипотеки
 * @type {Element}
 */
const mortgageSelector = document.querySelector('.j-mortgage');

if (mortgageSelector) {
    const mortgage = new Mortgage();

    mortgage.init(mortgageSelector);
}

// Добавляет активный класс табу "Ипотека" в карточке квартиры

const flatAnchor = document.querySelector('.j-anchor-tab-active');

if (flatAnchor) {
    const flatAnchorData = flatAnchor.getAttribute('data-scroll');
    const blockMortgage = document.querySelector('.j-mortgage');
    const tabs = blockMortgage.querySelectorAll('.purchase-tabs__button');
    const contentItem = blockMortgage.querySelectorAll('.purchase-tabs__content-item');

    const anchorText = document.querySelector('.j-mortgage-payment').textContent;

    const tabData = blockMortgage.querySelector(`.purchase-tabs__button[data-tab="${flatAnchorData}"]`);
    const contentData = blockMortgage.querySelector(`
        .purchase-tabs__content-item[data-tab-content="${flatAnchorData}"]
    `);

    const removeClass = (items) => {
        items.forEach((item) => {
            item.classList.remove('is-active');
        });
    };

    flatAnchor.addEventListener('click', () => {
        removeClass(tabs);
        removeClass(contentItem);
        tabData.classList.add('is-active');
        contentData.classList.add('is-active');
    });

    if (anchorText) {
        flatAnchor.querySelector('.link__text').textContent = anchorText;
    }
}

/**
 * Скролл вниз по клику на маленькую стрелочку
 * @type {Element}
 */
const arrowIcon = document.querySelector('.j-arrow-icon');

if (arrowIcon) {
    arrowIcon.addEventListener('click', () => {
        const clientHeight = window.innerHeight;
        const offsetY = window.pageYOffset;

        if (clientHeight - offsetY > 0) {
            $('body, html').animate({scrollTop: clientHeight - offsetY}, 1000);
        }
    });
}

// Анимация появления блоков
const revealElem = document.querySelector('.j-page-reveal-wrap');

if (revealElem) {
    initPageReveal({
        wrapper: revealElem
    });
}

// Favorite
const flatsElem = document.querySelector('.j-favorite');

if (flatsElem) {
    new Favorite().init({
        elem          : flatsElem,
        isFavoritePage: true
    });
}

if (Cookies.get('fav_id_counters')) {
    const header = document.querySelector('.j-header-favorite');

    if (header) {
        header.classList.add('is-active');
        header.dataset.cnt = parseInt(Cookies.get('fav_id_counters'), 10);
    }
}


// Уведомление об использовании куки.
const cookiesWrapper = document.querySelector('.j-cookies-notice');

if (cookiesWrapper) {
    const cookies = new CookiesNotice();

    cookies.init(cookiesWrapper);
}

// Попап с информацией о куках.
const cookiesBtn = Array.from(document.querySelectorAll('.j-cookies-popup'));

if (cookiesBtn) {
    const popupOptions = {
        openButtons         : cookiesBtn,
        closeButtonAriaLabel: 'Закрыть информацию',
        template            : 'classic',
        templateContent     : 'cookies',
        openLoadPage        : false
    };

    const popupCookies = new Popup(popupOptions);

    popupCookies.init();
}


// Ленивая загрузка
const lazyElements = Array.from(document.querySelectorAll('.lazy'));

if (lazyElements.length) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            yall({
                observeChanges: true
            });
        });
    } else {
        yall({
            observeChanges: true
        });
    }
}

observer.subscribe('lazyLoad:refresh', () => {
    yall({
        observeChanges: true
    });
});

// Подключение GTM из скриптов
const scriptHead = document.createElement('script');

scriptHead.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-KLDKSDN');`;

const scrtiptBody = document.createElement('noscript');

scrtiptBody.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KLDKSDN"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

const head = document.getElementsByTagName('head')[0];
const body = document.getElementsByTagName('body')[0];

head.insertBefore(scriptHead, head.lastChild);
body.insertBefore(scrtiptBody, body.lastChild);

const printPdfs = Array.from(document.querySelectorAll('.j-print-pdf'));

if (printPdfs.length) {
    printPdfs.forEach((item) => {
        if (item.classList.contains('j-print-pdf-mortgage') && item.dataset.pdf) {
            const query = new URLSearchParams();

            query.append(`price[min]`, U.accessStorage(`price[min]`));
            query.append(`first-pay[min]`, U.accessStorage(`first-pay[min]`));
            query.append(`limitation[min]`, U.accessStorage(`limitation[min]`));

            const encoded = decodeURI(query.toString());

            item.dataset.pdf = `${item.dataset.pdf}&${encoded}`;
        }
    });
    initPrintPdf(printPdfs);
}
